<template>
    <div>
        <Row :gutter="16" style="margin-bottom: 24px">
            <Col span="6">
                <Input v-model="query.keyword" placeholder="请输入企业名称、统一社会信用代码、法人姓名进行搜索" />
            </Col>
            <Col span="6">
            <Select v-model="query.auth_type" placeholder="认证方式" clearable style="width: 100%">
                <Option v-for="item in authOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
            </Select>
            </Col>
            <Col span="4">
                <Button type="primary" icon="ios-search" @click="search">搜索</Button>
            </Col>
        </Row>
        <Table border :loading="loading" :columns="columns" :data="tableData"> 
            <template slot-scope="{ row }" slot="action"> 
                
                <!-- v-if="row.business_license_url" -->
                <div  class="act_cla">
                    <Button 
                        type="primary" 
                        size="small" 
                        @click="handleViewBusinessLicense(row)"
                    >
                        查看营业执照
                    </Button>
                    <Button type="primary" v-if="row.authbook_path_url" size="small" @click="handleView(row)">查看授权书</Button> 
                    <Button type="success" size="small" @click="handleUnbind(row)">解绑认证</Button>
                </div>
            </template>
        </Table>
        <br />
        <Page :total="total" :current="query.page" :page-size="query.limit" style="text-align:right" show-elevator
            show-total @on-change="pageChange" />
    </div>
</template>

<script>
import { fetchEnterpriseUsers, unbindEnterpriseUser } from '@/api/userManage'

export default {
    data() {
        return {
            loading: false,
            query: {
                keyword: '',
                auth_type: '',
                page: 1,
                limit: 20
            },
            total: 0,
            authOptions: [
                { label: '全部', value: '' },
                { label: '企业认证', value: 1 }
            ],
            columns: [
                { title: '序号', type: 'index', width: 80, align: 'center' },
                { title: '企业名称', key: 'company_name', align: 'center' },
                { title: '统一社会信用代码', key: 'credit_code', align: 'center', width: 200 },
                { title: '法人名称', key: 'legal_name', align: 'center' },
                { title: '法人身份证号', key: 'legal_id_card', align: 'center', width: 180 },
                { title: '认证方式', key: 'auth_type', align: 'center' },
                { title: '认证时间', key: 'auth_time', align: 'center' },
                { title: '操作', slot: 'action', align: 'center', width: 320 }
            ],
            tableData: []
        }
    },
    created() {
        this.fetchList()
    },
    methods: {
        authMethodName(value) {
            const current = this.authOptions.find(item => item.value === value)
            return current ? current.label : value || '-'
        },
        pageChange(page) {
            this.query.page = page
            this.fetchList()
        },
        search() {
            this.query.page = 1
            this.fetchList()
        },
        fetchList() {
            this.loading = true
            fetchEnterpriseUsers(this.query).then(res => {
                const pageData = (res.data && res.data.data) || {}
                const list = pageData.data || []
                this.tableData = this.decorateList(list)
                // this.tableData = list
                this.total = pageData.total || list.length
                if (pageData.current_page) {
                    this.query.page = pageData.current_page
                }
            }).catch(err => {
                this.$Message.warning(err && err.msg ? err.msg : '获取企业用户失败，展示示例数据')
                // this.useMock()
            }).finally(() => {
                this.loading = false
            })
        },
        decorateList(list) {
            return list.map(item => ({
                id: item.id || '',
                company_name: item.company_name || item.real_name || '企业名称',
                credit_code: item.credit_code || item.id_card || '',
                legal_name: item.legal_name || item.real_name || '',
                legal_id_card: item.legal_id_card || item.id_card || '',
                auth_type: item.auth_type,
                auth_time: item.created_at || '',
                authbook_path_url: item.authbook_path_url || ''
            }))
        },
        useMock() {
            this.tableData = [
                { id: 1, company_name: '企业名称1', credit_code: 'vbcobf12345678912', legal_name: '法人名称1', legal_id_card: '236547891236584596', auth_method: 'carrier', auth_time: '2022-05-06' },
                { id: 2, company_name: '企业名称2', credit_code: 'vbcobf12345678912', legal_name: '法人名称2', legal_id_card: '236547891236584596', auth_method: 'face', auth_time: '2022-05-06' },
                { id: 3, company_name: '企业名称3', credit_code: 'vbcobf12345678912', legal_name: '法人名称3', legal_id_card: '236547891236584596', auth_method: 'face', auth_time: '2022-05-06' }
            ]
            this.total = this.tableData.length
        },
        handleView(row) {
            window.open(row.authbook_path_url || '') 
        },
        handleUnbind(row) {
            this.$Modal.confirm({
                title: '提示',
                content: `是否确认解绑${row.company_name}的认证？`,
                onOk: () => {
                    return unbindEnterpriseUser({ id: row.id }).then(res => {
                        this.$Message.success((res && res.msg) || '解绑成功')
                        this.fetchList()
                    }).catch(err => {
                        this.$Message.warning(err && err.msg ? err.msg : '解绑失败')
                        this.fetchList()
                    })
                }
            })
        }
    }
}
</script>
<style scoped>
.act_cla {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;    
}

</style>
